export class CComprobanteData {
    constructor(
        public Ruc?:string,
        public TipoComprobante?:number,
        public SerieNumero?:string,
        public FechaEmision?:string,
        public MontoTotal?:number,
        public CodigoCaptcha?:string,
    ){ }
}